import {Directive, ElementRef, HostListener, Output, EventEmitter} from '@angular/core';

import {Debounced, Throttle} from '../utils/throttle';

/**
 * 函数节流指令
 * 事件在n秒内连续被触发多次，函数只执行一次。
 * 例如：<button nz-button nzType="primary" nzSize="small" Throttle (throttleClick)="downloadFile(data)">下载</button>
 */

@Directive({
  selector: '[Throttle]'
})
export class ThrottleDirective {

  constructor(
    private el: ElementRef,
  ) {
  }

  @Output() throttleClick = new EventEmitter<any>();

  private throttle = new Throttle();
  private throttleUse = this.throttle.use(this.Click, this, 1000, true);

  @HostListener('click', ['$event']) onClick(event): void {
    const params = {
      element: this.el,
      event
    };
    this.throttleUse(params);
  }

  private Click(params): void {
    this.throttleClick.next(params);
  }

}
